import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className='footerContainer'>
      <h4>all rights are reserved to Ethicalottery Inc.</h4>
    </div>
  )
}

export default Footer
